export const LOCAL_DOMAIN = 'https://local.ecorp.cat.com';
export const ALLOW_CREDENTIALS = 'true';

export const REQUEST_ID_HEADER = 'x-cat-api-tracking-id';
export const SESSION_ID_HEADER = 'X-Cat-Pcc-Session-Id';
export const AKAMAI_EDGESCAPE_HEADER = 'X-Akamai-Edgescape';
export const PCC_LANG_HEADER = 'x-cat-pcc-lang';
export const PCC_ESITE_HEADER = 'x-cat-pcc-esite';
export const PCC_PAGE_HEADER = 'x-cat-pcc-page';
export const PCC_CURRENT_URL_HEADER = 'x-cat-pcc-current-url';
export const PCC_CURRENT_PATHNAME_HEADER = 'x-cat-pcc-current-pathname';
export const PCC_ADRUM_KEY_HEADER = 'x-cat-adrum-key';
export const ECT_QA_ENV_HEADER = 'x-cat-qa-env';
export const PCC_THOUSAND_EYES_HEADER = 'X-ThousandEyes-Agent';

export const REFERRER_HEADER = 'referer';
export const HOST_HEADER = 'x-forwarded-host';
export const GUEST_ORDER_INQ_EMAIL_HEADER = 'X-CAT-GUEST-ORDER-INQ-EMAIL';
export const HOST_HEADER_PROTOCOL = 'x-forwarded-proto';

export const REMOTE_IP = 'x-cat-remote-ip';
export const TRUE_CLIENT_IP = 'True-Client-IP';
export const FORWARDED_FOR = 'x-forwarded-for';

export const CONTENT_TYPE = 'application/json';
export const ACCEPT_HEADER = 'application/graphicsLocations-v1+json';
export const CONTENT_TYPE_HEADER = 'Content-Type';
export const CONTENT_TYPE_STREAM = 'application/octet-stream';
export const CONTENT_SECURITY_POLICY = 'Content-Security-Policy';
export const CONTENT_SECURITY_POLICY_HEADERS_CLIENT = `script-src 'self' 'unsafe-inline' t.contentsquare.net 'unsafe-eval' *; upgrade-insecure-requests; frame-ancestors 'self'`;
export const CONTENT_SECURITY_POLICY_HEADERS_API = `default-src 'none' frame-ancestors 'none'`;
export const CONTENT_TYPE_HEADER_CACHE_CONTROL = 'Cache-Control';
export const CONTENT_NO_CACHE = 'no-cache';
